import styled from "@emotion/styled";
import { AppNavbar } from "@features/Chat/components/AppNavbar";
import { useUIStore } from "@store/ui.store";
import {
  SIDEBAR_WIDTH_COLLAPSED_PX,
  SIDEBAR_WIDTH_EXPANDED_PX,
} from "@shared/layouts/sidebar-dimensions";

const LayoutContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  max-height: 100%;
  background-color: ${(p) => p.theme.colors.background};
`;

const HeaderSlot = styled.header<{ $isSidebarOpenDesktop?: boolean }>`
  flex-shrink: 0;
  background-color: ${(p) => p.theme.colors.background};
  display: flex;
  align-items: stretch;
  min-height: 4rem;

  ${(p) => p.theme.media.mobileDown} {
    min-height: 4.5rem;
  }

  & > * {
    width: 100%;
  }
  transition:
    margin-left 0.3s ease-in-out,
    width 0.3s ease-in-out;
  width: ${(p) =>
    p.$isSidebarOpenDesktop
      ? `calc(100% - ${SIDEBAR_WIDTH_EXPANDED_PX}px)`
      : `calc(100% - ${SIDEBAR_WIDTH_COLLAPSED_PX}px)`};
  margin-left: ${(p) =>
    p.$isSidebarOpenDesktop
      ? `${SIDEBAR_WIDTH_EXPANDED_PX}px`
      : `${SIDEBAR_WIDTH_COLLAPSED_PX}px`};

  ${(p) => p.theme.media.laptopDown} {
    width: 100%;
    margin-left: 0;
  }
`;

const ContentScroll = styled.div<{ $isSidebarOpenDesktop?: boolean }>`
  flex: 1;
  padding-left: 4rem;
  padding-right: 4rem;
  overflow-y: auto;
  padding-top: 1rem;
  padding-bottom: 1rem;
  transition:
    margin-left 0.3s ease-in-out,
    width 0.3s ease-in-out;
  width: ${(p) =>
    p.$isSidebarOpenDesktop
      ? `calc(100% - ${SIDEBAR_WIDTH_EXPANDED_PX}px)`
      : `calc(100% - ${SIDEBAR_WIDTH_COLLAPSED_PX}px)`};
  margin-left: ${(p) =>
    p.$isSidebarOpenDesktop
      ? `${SIDEBAR_WIDTH_EXPANDED_PX}px`
      : `${SIDEBAR_WIDTH_COLLAPSED_PX}px`};

  ${(p) => p.theme.media.laptopDown} {
    width: 100%;
    margin-left: 0;
    padding: 1rem;
  }
`;

export const PresentationsLayout = ({
  children,
  header,
}: {
  children?: React.ReactNode;
  header?: React.ReactNode;
}) => {
  const isSidebarOpenDesktop = useUIStore(
    (state) => state.isSidebarOpenDesktop,
  );

  return (
    <LayoutContainer>
      <HeaderSlot $isSidebarOpenDesktop={isSidebarOpenDesktop}>
        {header ?? <AppNavbar />}
      </HeaderSlot>
      <ContentScroll $isSidebarOpenDesktop={isSidebarOpenDesktop}>
        {children}
      </ContentScroll>
    </LayoutContainer>
  );
};
